<template>
	<div>
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div>
			<v-text-field
				type="number"
				data-lpignore="true"
				:prefix="prefix"
				:suffix="suffix"
				class="widget-input-field"
				:ref="fieldRef"
				v-model.number="value"
				v-bind="activeFormFieldCommonProps"
				:placeholder="placeholder"
			/>
		</div>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';

export default {
	name: 'NumberInputField',
	components: {
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	props: {
		prefixValue: { type: String, default: '' },
		suffixValue: { type: String, default: '' },
	},
	computed: {
		placeholder() {
			if (!this.field.metadata.options.placeholder.enabled) {
				return '';
			}
			return this.field.metadata.options.placeholder.value;
		},
		fieldOutput() {
			return this.fieldMetadata.output;
		},
		fieldValidations() {
			return this.fieldMetadata.validations;
		},
		prefix() {
			return this.fieldOutput.prefix;
		},
		suffix() {
			return this.fieldOutput.suffix;
		},

		minNumberValidation() {
			return this.fieldValidations.min_number;
		},
		maxNumberValidation() {
			return this.fieldValidations.max_number;
		},
		decimalValidation() {
			return this.fieldValidations.decimal;
		},
		customFieldValidation() {
			const isNumber = (input) => !isNaN(input);

			const rules = [];
			if (!this.field.metadata.options.required.enabled && this.value === '') {
				return [];
			}
			if (this.minNumberValidation.enabled) {
				rules.push((v) => {
					if (isNumber(v) && Number(v) > Number(this.minNumberValidation.value)) {
						return true;
					} else {
						return `Must be bigger than ${this.minNumberValidation.value}`;
					}
				});
			}
			if (this.maxNumberValidation.enabled) {
				rules.push((v) => {
					if (isNumber(v) && Number(v) < Number(this.maxNumberValidation.value)) {
						return true;
					} else {
						return `Must be smaller than ${this.maxNumberValidation.value}`;
					}
				});
			}
			if (this.decimalValidation.enabled) {
				rules.push((v) => {
					const decimalSeparator = '.';
					const numberOfDigitsAfterDecimalPointAllowed = this.decimalValidation.value;
					const numberOfDigitsAfterDecimalPoint = String(v).split(decimalSeparator)[1]?.length || 0;
					if (numberOfDigitsAfterDecimalPoint > numberOfDigitsAfterDecimalPointAllowed) {
						return `Must be a number with no more than ${numberOfDigitsAfterDecimalPointAllowed} digits after the decimal point`;
					} else {
						return true;
					}
				});
			}
			return rules;
		},
		decimalSeperator() {
			return this.fieldOutput.decimal_seperator;
		},
		thousandsSeperator() {
			return this.fieldOutput.thousands_seperator;
		},
	},
};
</script>
